import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ spacing }: Theme) => ({
  validationMessage: {
    marginTop: spacing(),
    marginBottom: 0,
    width: '100%',
  },
  validationMessageCepikAbTest: {
    marginBottom: 0,
    width: '100%',
  },
  alertTop: {
    marginBottom: 20,
  },
}));
